export default __webpack_public_path__ + "assets/Lato-Thin.5a60dde25d817751d5908f07e7773374.ttf";